import React from 'react';
import './ConfirmationPopup.css';

interface IConfirmationPopupProps {
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmButtonStyle?: 'danger' | 'primary';
}

export const ConfirmationPopup = ({
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    confirmButtonStyle = 'primary'
}: IConfirmationPopupProps) => {
    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };

    return (
        <div className="ConfirmationPopup_overlay" onClick={handleBackdropClick}>
            <div className="ConfirmationPopup_content" onClick={(e) => e.stopPropagation()}>
                <div className="ConfirmationPopup_message">
                    {message}
                </div>
                <div className="ConfirmationPopup_actions">
                    <button className="ConfirmationPopup_cancel" onClick={onCancel}>
                        {cancelText}
                    </button>
                    <button 
                        className={`ConfirmationPopup_confirm ConfirmationPopup_confirm--${confirmButtonStyle}`}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
